import Vue from 'vue';
import 'layers-design-system/src/style/element-variables.scss'
import LayersDesignSystem from 'layers-design-system'

Vue.use(LayersDesignSystem)

export default LayersDesignSystem;